/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100CsoPortalBadGatewayException,
  ErrorResponseOfPtw100CsoPortalServiceUnavailableException,
  ErrorResponseOfPtw100InternalServerException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100NotFoundException,
  ErrorResponseOfPtw100UnauthorizedException,
  ErrorResponseOfPtw100UnprocessableContentException,
  SupportRequestDto,
} from '../models/index';
import {
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100CsoPortalBadGatewayExceptionFromJSON,
    ErrorResponseOfPtw100CsoPortalBadGatewayExceptionToJSON,
    ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionFromJSON,
    ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionToJSON,
    ErrorResponseOfPtw100InternalServerExceptionFromJSON,
    ErrorResponseOfPtw100InternalServerExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100NotFoundExceptionFromJSON,
    ErrorResponseOfPtw100NotFoundExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    ErrorResponseOfPtw100UnprocessableContentExceptionFromJSON,
    ErrorResponseOfPtw100UnprocessableContentExceptionToJSON,
    SupportRequestDtoFromJSON,
    SupportRequestDtoToJSON,
} from '../models/index';

export interface DeRegisterQaEquipmentRequest {
    id: string;
}

export interface RegisterQaEquipmentRequest {
    id: string;
}

export interface RequestCalibrationDataSupportForDeviceRequest {
    id: string;
    supportRequestDto?: SupportRequestDto;
}

export interface RequestSerialNumberAssignmentSupportForDeviceRequest {
    id: string;
    supportRequestDto?: SupportRequestDto;
}

export interface RequestSupportForDeviceRequest {
    id: string;
    supportRequestDto?: SupportRequestDto;
}

/**
 * 
 */
export class QaEquipmentCloudApi extends runtime.BaseAPI {

    /**
     */
    async deRegisterQaEquipmentRaw(requestParameters: DeRegisterQaEquipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deRegisterQaEquipment().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}/deregister`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
          case 422: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnprocessableContentExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnprocessableContentException" as const);
					}
          case 502: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100CsoPortalBadGatewayExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100CsoPortalBadGatewayException" as const);
					}
          case 503: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100CsoPortalServiceUnavailableException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async deRegisterQaEquipment(requestParameters: DeRegisterQaEquipmentRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentCloudApi['deRegisterQaEquipmentRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.deRegisterQaEquipmentRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async registerQaEquipmentRaw(requestParameters: RegisterQaEquipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling registerQaEquipment().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}/register`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
          case 502: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100CsoPortalBadGatewayExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100CsoPortalBadGatewayException" as const);
					}
          case 503: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100CsoPortalServiceUnavailableException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async registerQaEquipment(requestParameters: RegisterQaEquipmentRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentCloudApi['registerQaEquipmentRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.registerQaEquipmentRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async requestCalibrationDataSupportForDeviceRaw(requestParameters: RequestCalibrationDataSupportForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling requestCalibrationDataSupportForDevice().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}/calibration-support-request`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRequestDtoToJSON(requestParameters['supportRequestDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
          case 500: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100InternalServerExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100InternalServerException" as const);
					}
          case 502: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100CsoPortalBadGatewayExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100CsoPortalBadGatewayException" as const);
					}
          case 503: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100CsoPortalServiceUnavailableException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async requestCalibrationDataSupportForDevice(requestParameters: RequestCalibrationDataSupportForDeviceRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentCloudApi['requestCalibrationDataSupportForDeviceRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.requestCalibrationDataSupportForDeviceRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async requestSerialNumberAssignmentSupportForDeviceRaw(requestParameters: RequestSerialNumberAssignmentSupportForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling requestSerialNumberAssignmentSupportForDevice().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}/sn-assignment-request`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRequestDtoToJSON(requestParameters['supportRequestDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
          case 500: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100InternalServerExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100InternalServerException" as const);
					}
          case 502: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100CsoPortalBadGatewayExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100CsoPortalBadGatewayException" as const);
					}
          case 503: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100CsoPortalServiceUnavailableException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async requestSerialNumberAssignmentSupportForDevice(requestParameters: RequestSerialNumberAssignmentSupportForDeviceRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentCloudApi['requestSerialNumberAssignmentSupportForDeviceRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.requestSerialNumberAssignmentSupportForDeviceRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async requestSupportForDeviceRaw(requestParameters: RequestSupportForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling requestSupportForDevice().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/qa-equipment/{id}/support-request`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRequestDtoToJSON(requestParameters['supportRequestDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
          case 500: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100InternalServerExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100InternalServerException" as const);
					}
          case 502: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100CsoPortalBadGatewayExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100CsoPortalBadGatewayException" as const);
					}
          case 503: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100CsoPortalServiceUnavailableExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100CsoPortalServiceUnavailableException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async requestSupportForDevice(requestParameters: RequestSupportForDeviceRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<QaEquipmentCloudApi['requestSupportForDeviceRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.requestSupportForDeviceRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
